const LOG_LEVELS = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info'
};

const logError = (message, error = null) => {
  console.error(`[ERROR] ${message}`, error);
};

const logWarning = (message) => {
  console.warn(`[WARN] ${message}`);
};

const logInfo = (message) => {
  console.info(`[INFO] ${message}`);
};

export { logError, logWarning, logInfo };